<div class="wrapperFlight">
    <div class="image_wrapper_">
        <img src="../../../../../assets/belairtrip_assets/svg_icon/No_flights_Found.svg" alt="No Flight Found" class="img-fluid">
    </div>
    <div class="content">
        <h3>No Results Found</h3>
        <p>Sorry! We could not find any flight for this search. Please search again</p>
        <button mat-button class="mainButton" routerLink="/">Search Again</button>
    </div>
</div>